import Vapi from '@borisp/vuex-rest-api'
import * as R from 'ramda'
import { getDataFromPayload } from 'utils/helpers'
import enumsTranslations from 'enumsTranslations'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

const prepareEnumsForMap = R.map(
  R.map(
    R.compose(
      R.reverse,
      R.values
    )
  ),
  R.compose(
    R.flatten,
    R.values
  )
)

const getTranslatedEnums = enums => R.reduce((acc, key) => ({
  ...acc,
  [key]: R.map(({ value, name }) => ({
    name: typeof enumsTranslations[value] !== 'undefined' ? enumsTranslations[value][localStorage.ui_language] || name : name,
    value
  }), enums[key])
}), {}, R.keys(enums))

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    enums: {},
    enumsMap: new Map()
  }
})
  .get({
    action: 'getEnums',
    property: 'enums',
    path: '/enums/',
    onSuccess: (state, payload) => {
      const enums = getTranslatedEnums(getDataFromPayload(payload))
      const enumsList = prepareEnumsForMap(enums)

      state.enums = enums
      state.enumsMap = new Map(enumsList)
    }
  })
  .getStore()
